import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DraggableDirective } from '@shared/directive/draggable';
import { VibrationRecord } from '@shared/models/vibration-record';
import { VibrationsRecordService } from '@shared/services/records/vibrations-record.service';
import { FonctionsService } from '@shared/services/utilities/fonctions.service';

@Component({
  selector: 'app-distance-modal',
  imports: [TranslateModule, MatIconModule, CommonModule, DraggableDirective, FormsModule],
  templateUrl: './distance-modal.component.html',
  styleUrl: './distance-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DistanceModalComponent implements OnInit {
  title: string = 'Confirm';
  message: string = 'Are you sure?';
  distance: number;
  siteId: number;
  constructor(
    public dialogRef: MatDialogRef<DistanceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private vibrationRecordService: VibrationsRecordService,
    private fonctionsService: FonctionsService

  ) { }
  ngOnInit(): void {
    this.distance = this.data.distance ? this.data.distance : null;
    console.log(this.distance);
    this.siteId = this.data.siteId;


  }

  onConfirm(): void {
    // this.data.record.distance = this.distance;
    let record: VibrationRecord = new VibrationRecord();
    record.information = {
      currentURL: window.location.href,
      regionName: ' ',
      siteName: ' ',
      controlPointName: '',
    };
    record.vibrationRecord = this.data.record;
    record.vibrationRecord.distance = this.distance;
    console.log(record);
    this.vibrationRecordService.updateRecord(this.siteId, record.vibrationRecord.id.toString(), record).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true, 'Distance updated successfully');
        this.dialogRef.close(false);

      },
      error: (err: any) => {
      }
    });
  }
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
